import React from "react";
import PropTypes from "prop-types";
import withStyles from "components/with-styles";
import { DataGridItem } from "components/data-grid";
import styles from "./styles/page-header-bar-buttons.css.js";

const PageHeaderBarButtons = ({ buttons, classes, onlyIcon = false }) =>
  buttons ? (
    <DataGridItem
      className={classes.page_header_bar_buttons}
      small
      sizesOverride={onlyIcon ? { xl: 1, lg: 1, md: 1, sm: 1, xs: 1 } : {}}
    >
      {buttons}
    </DataGridItem>
  ) : null;

PageHeaderBarButtons.propTypes = {
  /**
   * Elemento con el contenido de la botonera
   */
  buttons: PropTypes.element,
  /**
   * Indica que no hay título
   */
  onlyIcon: PropTypes.bool,
};

export default withStyles(styles)(PageHeaderBarButtons);
